import { css } from 'lit';

export const style = css`
  .lender__payoff_amount {
    margin-top: 1em;
  }
`;
